import type { AbTestAttributes } from "@solvari/ab-testing";

import { localeToIso } from "@solvari/translations";

import { hostAndUrlToLocale } from "~/shared/locale/hostLocale.ts";

// Nuxt-free so client plugin and Nitro layer derive `siteLocale` from the same host + path.
function siteAttributes({
  host,
  pathname,
}: {
  host: string;
  pathname: string;
}): Pick<AbTestAttributes, "siteLocale" | "siteType"> {
  return {
    siteLocale: localeToIso(hostAndUrlToLocale(host, pathname)),
    siteType: "platform",
  };
}

export { siteAttributes };
